import type { CFaqTranslations } from "./pl";

export const en: CFaqTranslations = {
  emptyData: "No data to display.",
  emptyList: "There are currently no entries in this section.",
  formatQuestion: (index, question) => `${index}. ${question}`,
  searchLabel: "Search questions",
  searchPlaceholder: "Type to filter questions…",
  formatEmptyResults: (query) => `No questions match "${query}".`,
};
